import { cn } from "@/lib/utils";
import React, { FC, SVGProps } from "react";

const TwitterIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => {
  return (
    <svg
      className={cn("fill-black", className)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.2706 1.58667H18.0818L11.9401 8.60625L19.1654 18.1583H13.5081L9.07706 12.365L4.00699 18.1583H1.19406L7.76323 10.6501L0.832031 1.58667H6.63296L10.6382 6.88195L15.2706 1.58667ZM14.284 16.4757H15.8417L5.78653 3.18095H4.11492L14.284 16.4757Z" />
    </svg>
  );
};

export default TwitterIcon;
